import { getRatesZoneByIdRequest } from "../../data/ratesZoneApi";

function getPayloadData(response) {
  return response?.data?.data || response?.data || null;
}

export async function getTarifaZoneByIdUseCase(id) {
  if (!id) {
    throw new Error("El id de la tarifa de zona es obligatorio.");
  }

  return getPayloadData(await getRatesZoneByIdRequest(id));
}
